module.exports = __webpack_public_path__ + "img/recruit-icon-2.7dd06a5c.png";